import { Type } from 'class-transformer'
import { DocumentStatusEnum } from 'common/enum/document-status'
import { ClassProps } from 'common/utils/getClassProps'
import { User } from 'domain/entities/user-model'

export class Document {
  document_id!: number
  type!: string
  name!: string
  documentUri?: string
  status?: string
  sendedAt?: string
  updatedAt?: string
  base64?: string
  extension?: string
  group_id?: string
  created_at?: string

  @Type(() => Date)
  conclusionDate?: Date | string | undefined

  constructor(props?: Partial<DocumentProps>) {
    Object.assign(this, props)
  }
}

type DocumentProps = ClassProps<typeof Document.prototype>

// new SurgicalOrder page
export type DocumentsNew = {
  type: string
  status: DocumentStatusEnum
  status_updated_at?: Date | string | undefined
  status_updated_by?: User
  documents: DocumentNew[]
}

export type DocumentNew = {
  document_id: number
  type: string
  name: string
  is_validated?: boolean
  document_uri?: string
  is_merged?: boolean
  group_id?: string
  status?: DocumentStatusEnum
  status_updated_at?: Date | string | undefined
  status_updated_by?: User
  patient_id: number | undefined
  sended_at?: Date | string | undefined
  updated_at?: Date | string | undefined
  conclusion_date?: Date | string | undefined
  created_by: User
  // base64?: string
  // extension?: string
}
